import { useItApplicationsMetrics } from '../../hooks/useItApplicationsMetrics';
import { MetricCard } from '../MetricCard';
import { useNavigate } from 'react-router';

type ITApplicationsWidgetProps = {
  locationUuid: string;
};

export const ITApplicationsWidget = ({
  locationUuid,
}: ITApplicationsWidgetProps) => {
  const navigate = useNavigate();

  const { data, loading } = useItApplicationsMetrics(locationUuid);

  const totalApplications = data?.applicationCount ?? 0;
  const mappedApplications = data?.mappedApplicationsCount ?? 0;

  const handleViewApplications = () => {
    navigate(
      `/cyber-hub/it-applications${
        locationUuid ? `?locationId=${locationUuid}` : ''
      }`,
    );
  };
  return (
    <MetricCard
      title="It Applications"
      tooltipText="Total number of IT Applications in the platform."
      topMetric={{
        value: totalApplications ?? 0,
        description: 'Total Applications',
      }}
      bottomMetric={{
        value: mappedApplications ?? 0,
        description: 'Applications Mapped',
      }}
      onViewClick={handleViewApplications}
      isLoading={loading}
      showViewButton={true}
    />
  );
};
